import produce from 'immer';

import * as actions from './actions';

export default produce((state, action) => {
  switch (action.type) {
  case actions.SET_SORT_BY:
    state.direction = (state.sortBy === action.sortBy && state.direction === 'asc') ? 'desc' : 'asc'; 
    state.sortBy = action.sortBy;
    break;
  }
}, {});
